class LightboxThumbnails extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.revealImage = this.revealImage.bind(this)

    if (window.BAO.MediaBreakpoints.isMd) {
      this.els?.thumbnail?.elements.forEach((thumbnailEl) => {
        this.listeners.add(thumbnailEl, 'click', this.revealImage)
      })
    }

    this.initGalleryObserver()
  }

  revealImage (event) {
    const index = event.target.closest(
      '[data-lightbox-thumbnails-el="thumbnail"]',
    ).dataset.index
    const media = this.els.image.elements[index]
    if (media) {
      media.scrollIntoView({
        behavior: 'smooth',
        inline: 'nearest',
        block: 'start',
      })
    }
  }

  initGalleryObserver () {
    const options = {
      root: this.els.image.container,
      rootMargin: '0px 0px -70% 0px',
      threshold: 0,
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const index = Array.from(this.els.image.elements).indexOf(
            entry.target,
          )

          if (index > -1) {
            this.els.thumbnail.elements.forEach((thumbnailEl) => {
              thumbnailEl.classList.remove('mod-Modal_ThumbItem-active')
            })
            this.els.thumbnail.elements[index].classList.add(
              'mod-Modal_ThumbItem-active',
            )
          }
        }
      })
    }, options)

    this.els.image.elements.forEach((img) => observer.observe(img))
  }
}

if (!customElements.get('lightbox-thumbnails')) {
  customElements.define('lightbox-thumbnails', LightboxThumbnails)
}
